import gql from "graphql-tag";

export const DELETE_USER_QUERY = gql`
  mutation DeleteUserMutation($id: ID!) {
    deleteUser(where: { id: $id }) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/DeleteUser/queries.ts